module.exports = {
      id: "account-shield-usage",
      viewBox: undefined,
      url: __webpack_public_path__ + "img/icons.09862bea.svg#account-shield",
      toString: function () {
        return this.url;
      }
    }